import {combineEpics, ofType, OKDialogActions, PledgerAction, PledgerEpic} from "@pledger/frontend-commons";
import {map} from "rxjs/operators";
import {SouscriptionSuiviActions} from "./SouscriptionSuiviActions";
import {souscriptionSuiviWServiceActions} from "../../services/ws/SouscriptionSuivi/souscriptionSuiviWServiceActions";
import {AppActions} from "../app/AppActions";

/*const emptyEpic : PledgerEpic<any> = (actions$ : Observable<PledgerAction>) => of(AppActions.EMPTY_ACTION.build());*/

const pageLoadedEpic : PledgerEpic<any> = (actions$) =>
    actions$.pipe(
        ofType(SouscriptionSuiviActions.SOUSCRIPTION_SUIVI_PAGE_LOADED_ACTION.type),
        map((action : PledgerAction) => {
           return souscriptionSuiviWServiceActions.GET_SOUSCRIPTION_PROGRESS_ACTION.build(action.payload.souscriptionId);
        }));

const suiviSouscriptionEmailSentEpic : PledgerEpic<any> = (action$,state$) =>
    action$.pipe(
        ofType(souscriptionSuiviWServiceActions.RESENT_SOUSCRIPTION_EMAIL_SUCCEEDED_ACTION.type),
        map((action : PledgerAction) => {
            const appContext = state$.value.appContext;
            const customColors = appContext.customColors;
            return OKDialogActions.SHOW_OKDIALOG_ACTION.build('L\'email de souscription a été renvoyé avec succès.',
                'Envoi de l\'email',
                customColors.PLEDGER_GREEN_COLOR,customColors.PLEDGER_GREEN_SHADOW_COLOR,
                AppActions.EMPTY_ACTION,
                'Ok',
                140,
                'ModalOverlay',
                540,
                280);
        })
    );

const suiviSouscriptionEmailSentFailedEpic : PledgerEpic<any> = (action$,state$) =>
    action$.pipe(
        ofType(souscriptionSuiviWServiceActions.RESENT_SOUSCRIPTION_EMAIL_FAILED_ACTION.type),
        map((action : PledgerAction) => {
            const appContext = state$.value.appContext;
            const customColors = appContext.customColors;
            return OKDialogActions.SHOW_OKDIALOG_ACTION.build('Erreur : l\'email de souscription n\'a pas pu être renvoyé.',
                'Envoi de l\'email',
                customColors.PLEDGER_GREEN_COLOR,customColors.PLEDGER_GREEN_SHADOW_COLOR,
                AppActions.EMPTY_ACTION,
                'Ok',
                140,
                'ModalOverlay',
                540,
                280);
        })
    );

export const souscriptionSuiviEpics = combineEpics(
    pageLoadedEpic,
    suiviSouscriptionEmailSentEpic,
    suiviSouscriptionEmailSentFailedEpic
);
